


































import { Component, Prop, Vue } from 'vue-property-decorator';
import { AddressAttribute, AddressAttributeOption } from '@/store/models';
import getValidationRules from '@/commons/formFieldValidationRules';

@Component({})
export default class FormSelectField extends Vue {
    @Prop() public addressAttribute!: AddressAttribute;
    @Prop() public modelValue!: any;
    @Prop() public options!: AddressAttributeOption[];

    get validationRules() {
        return getValidationRules(this.addressAttribute);
    }

    public updateModelValue(e: any) {
        let { value } = e.target;

        // Workaround for string code to int
        if (this.addressAttribute.code === 'region_id') {
            value = +value;
        }

        this.$emit('updateModelValue', [value, this.addressAttribute.code]);
    }
}
